import styled from "styled-components";
import { theme } from "../theme";

// Reply Message Styles
export const ReplyContainer = styled.div`
  background: ${theme.colors.background.primary};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  box-shadow: ${theme.shadows.light};
`;

export const ReplyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
`;

export const ReplyOriginalMessage = styled.div`
  background: ${theme.colors.background.secondary};
  border-left: 3px solid ${theme.colors.primary};
  padding: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.sm};
  border-radius: 0 ${theme.borderRadius.sm} ${theme.borderRadius.sm} 0;
`;

export const ReplyContent = styled.div`
  margin-bottom: ${theme.spacing.sm};
`;

export const ReplyActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`;

export const ReplyButton = styled.button<{ disabled?: boolean }>`
  background: ${props => props.disabled ? theme.colors.text.secondary : theme.colors.primary};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

// Forward Message Styles
export const ForwardContainer = styled.div`
  background: ${theme.colors.background.primary};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  box-shadow: ${theme.shadows.light};
  max-height: 500px;
  overflow-y: auto;
`;

export const ForwardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
`;

export const ForwardOriginalMessage = styled.div`
  background: ${theme.colors.background.secondary};
  border-left: 3px solid ${theme.colors.primary};
  padding: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.md};
  border-radius: 0 ${theme.borderRadius.sm} ${theme.borderRadius.sm} 0;
`;

export const ForwardContent = styled.div`
  margin-bottom: ${theme.spacing.sm};
`;

export const ConversationSelector = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.sm};
  margin-top: ${theme.spacing.sm};
`;

export const ConversationOption = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.sm};
  cursor: pointer;
  border-bottom: 1px solid ${theme.colors.border};
  background: ${props => props.$isSelected ? 'rgba(102, 126, 234, 0.1)' : 'transparent'};
  
  &:hover {
    background: ${props => props.$isSelected ? 'rgba(102, 126, 234, 0.15)' : theme.colors.background.secondary};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const ConversationAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.light};
  font-weight: 600;
  font-size: 0.875rem;
  margin-right: ${theme.spacing.sm};
  flex-shrink: 0;
`;

export const ConversationInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConversationName = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${theme.spacing.sm};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.sm};
  font-size: 0.875rem;
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
  }
`;

export const ForwardActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`;

export const ForwardButton = styled.button<{ disabled?: boolean }>`
  background: ${props => props.disabled ? theme.colors.text.secondary : theme.colors.primary};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

// Edit Message Styles
export const EditContainer = styled.div`
  background: ${theme.colors.background.primary};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  box-shadow: ${theme.shadows.light};
`;

export const EditHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.sm};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
`;

export const EditContent = styled.div`
  margin-bottom: ${theme.spacing.sm};
`;

export const EditActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`;

export const EditButton = styled.button<{ disabled?: boolean }>`
  background: ${props => props.disabled ? theme.colors.text.secondary : theme.colors.primary};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

// Delete Message Styles
export const DeleteContainer = styled.div`
  background: ${theme.colors.background.primary};
  border: 1px solid ${theme.colors.error};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.sm};
  box-shadow: ${theme.shadows.light};
`;

export const DeleteHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.sm};
  font-size: 0.875rem;
  font-weight: 600;
  color: ${theme.colors.error};
`;

export const DeleteContent = styled.div`
  margin-bottom: ${theme.spacing.sm};
`;

export const DeleteMessage = styled.div`
  background: ${theme.colors.background.secondary};
  border-left: 3px solid ${theme.colors.error};
  padding: ${theme.spacing.sm};
  border-radius: 0 ${theme.borderRadius.sm} ${theme.borderRadius.sm} 0;
`;

export const DeleteActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`;

export const DeleteButton = styled.button<{ disabled?: boolean; $isDeleting?: boolean }>`
  background: ${props => props.disabled ? theme.colors.text.secondary : theme.colors.error};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all ${theme.transitions.normal};
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const WarningIcon = styled.span`
  font-size: 1.2rem;
`;

// Common Styles
export const CancelButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.text.secondary};
  cursor: pointer;
  font-size: 0.875rem;
  padding: ${theme.spacing.xs};
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.normal};
  
  &:hover {
    background: ${theme.colors.background.secondary};
    color: ${theme.colors.text.primary};
  }
`;

export const CharacterCount = styled.div<{ $isOverLimit: boolean }>`
  font-size: 0.75rem;
  color: ${props => props.$isOverLimit ? theme.colors.error : theme.colors.text.secondary};
  text-align: right;
  margin-top: ${theme.spacing.xs};
`;
